<template>
  <label class="app-sw-row" :class="{ 'app-sw-row--line': line, 'app-sw-row--disabled': disabled }">
    <span class="app-sw-row__label"><slot>{{ label }}</slot></span>
    <button
      type="button"
      role="switch"
      class="app-sw"
      :aria-checked="value ? 'true' : 'false'"
      :disabled="disabled"
      v-bind="$attrs"
      @click="toggle"
    >
      <span class="app-sw__thumb" aria-hidden="true">
        <app-icon v-if="value && !disabled" name="check" :size="10" :stroke-width="3" class="app-sw__check" />
      </span>
    </button>
  </label>
</template>

<script>
// Schalterzeile (Spezifikation 2.6): die ganze Zeile ist ein <label> und schaltet (40/48 hoch), Schalter rechts als
// <button role="switch" aria-checked>. value (Boolean) mit v-model; Ereignisse input und change (Boolean).
// line: Trennlinie oben (Standard true).
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppSwitchRow',
  components: { AppIcon },
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    line: { type: Boolean, default: true }
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      const next = !this.value;
      this.$emit('input', next);
      this.$emit('change', next);
    }
  }
};
</script>
